import { css } from 'lit';
import componentStyles from '../styles/component.styles';
export default css `
${componentStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
  display: inline-block;
}

.tag {
  font-size: var(--p-tag-font-size, 0.8rem);
  border-radius: 0.3rem;
  padding: 0.25rem 0.4rem;
  line-height: 1;
  border: 1px solid var(--p-border);
  background-color: var(--p-tag-background-color, var(--p-text-color-contrast-100));
  display: flex;
  align-items: center;
}

`;
